import { NgComponentOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { of } from 'rxjs';

import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

import { BottomSheetTemplateBasicComponent, BottomSheetTemplateGenericComponent } from '@camelot/menu';
import { LayoutModalComponent, ValidationModal } from '@camelot/ui';

import { TestIdDirective } from '@camelot/testing-harness';

const dialogRefMock = {
  addPanelClass: () => void 0,
  close: () => void 0,
  removePanelClass: () => void 0,
};

@Component({
    imports: [
        BottomSheetTemplateBasicComponent,
        BottomSheetTemplateGenericComponent,
        LayoutModalComponent,
        NgComponentOutlet,
        TestIdDirective,
    ],
    providers: [
        { provide: MatDialogRef, useValue: dialogRefMock },
        { provide: MAT_DIALOG_DATA, useValue: { title: 'Dialog title' } },
        {
            provide: MAT_BOTTOM_SHEET_DATA,
            useValue: { menu$: of([]), orientation: 'vertical' },
        },
    ],
    template: `
    <cam-layout-modal camTestId="cam-layout-modal">modal content</cam-layout-modal>
    <div camTestId="cam-validation-modal">
      <ng-container *ngComponentOutlet="this.validationModal" />
    </div>
    <cam-bottom-sheet-template-basic camTestId="cam-bottom-sheet-template-basic" />
    <cam-bottom-sheet-template-generic camTestId="cam-bottom-sheet-template-generic" />
  `
})
export class UiModalCase {
  public validationModal = ValidationModal;
}
